import { useState, useMemo, useCallback } from 'react';

const LOADING_STATE = 'loading'; // 加载中
const LOAD_STATE_SUCCESS = 'loadStateSuccess'; // 加载成功
const LOAD_STATE_FAILED = 'loadStateFailed'; // 加载失败

/**
 * 加载状态控制Hooks
 *
 * @returns
 */
export const useLoadingHooks = () => {
  // 三个状态只会存在其一
  const [currentState, setCurrentState] = useState(LOADING_STATE);

  const isLoading = useMemo(() => {
    return currentState === LOADING_STATE;
  }, [currentState]);

  const isLoadSuccess = useMemo(() => {
    return currentState === LOAD_STATE_SUCCESS;
  }, [currentState]);

  const isLoadFailed = useMemo(() => {
    return currentState === LOAD_STATE_FAILED;
  }, [currentState]);

  const setLoadingState = useCallback(() => {
    setCurrentState(LOADING_STATE);
  }, []);
  const setSuccessState = useCallback(() => {
    setCurrentState(LOAD_STATE_SUCCESS);
  }, []);
  const setFailState = useCallback(() => {
    setCurrentState(LOAD_STATE_FAILED);
  }, []);

  return {
    isLoading,
    isLoadSuccess,
    isLoadFailed,

    setLoadingState,
    setSuccessState,
    setFailState,
  };
};
